import { Modal, Button } from "antd";
import { MapPin, Users, Eye, ClipboardList } from "lucide-react";
import dayjs from "dayjs";

function DayOptionsModal({
  visible,
  date,
  onClose,
  onCreateExcursion,
  onCreateGroup,
  onViewActiveGroups,
  onCreateTask,
}) {
  if (!date) return null;

  const formattedDate = dayjs(date).format("DD/MM/YYYY");

  return (
    <Modal
      title={`Opciones para ${formattedDate}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col gap-3 py-4">
        <Button
          block
          size="large"
          icon={<MapPin size={18} />}
          onClick={onCreateExcursion}
          className="flex items-center justify-center gap-2"
        >
          Crear Excursión
        </Button>
        <Button
          block
          size="large"
          icon={<Users size={18} />}
          onClick={onCreateGroup}
          className="flex items-center justify-center gap-2"
        >
          Crear Grupo
        </Button>
        <Button
          block
          size="large"
          icon={<Eye size={18} />}
          onClick={onViewActiveGroups}
          className="flex items-center justify-center gap-2"
        >
          Ver Grupos Activos
        </Button>
        <Button
          block
          size="large"
          icon={<ClipboardList size={18} />}
          onClick={onCreateTask}
          className="flex items-center justify-center gap-2"
        >
          Crear Tarea
        </Button>
      </div>
    </Modal>
  );
}

export default DayOptionsModal;
